/**
 * Home Page Wrapper for ISR
 *
 * Performance optimizations:
 * - Desktop and Mobile variants are in SEPARATE files with their own imports
 * - Each variant uses dynamic() for below-the-fold components
 * - Only the needed platform variant is loaded via dynamic import
 * - Above-the-fold components are statically imported in each variant
 */

import React from 'react';
import dynamic from 'next/dynamic';
import {DynamicPageServerSideProps} from '@/_application/core/types';
import {useIsrPageInit} from '@/_application/pages/_isr';

// Platform-specific components — only the needed variant is loaded
const HomePageDesktopIsr = dynamic(() => import('./home-page-desktop-isr'), {ssr: true});
const HomePageMobileIsr = dynamic(() => import('./home-page-mobile-isr'), {ssr: true});

export interface HomePageWrapperProps {
    variables?: DynamicPageServerSideProps['variables'];
    isMobile?: boolean;
    layout?: DynamicPageServerSideProps['layout'];
}


/**
 * Home Page Wrapper for ISR
 * Entry point that selects mobile or desktop version
 * Uses centralized useIsrPageInit to handle storeServerData and get customer
 */
export const HomePageWrapper: React.FC<HomePageWrapperProps> = ({variables, isMobile}) => {
    // Initialize ISR page - handles storeServerData and returns customer
    const customer = useIsrPageInit(variables);

    if (!variables) {
        return null;
    }

    if (isMobile) {
        return <HomePageMobileIsr variables={variables} customer={customer} />;
    }

    return <HomePageDesktopIsr variables={variables} customer={customer} />;
};

export default HomePageWrapper;
